/**
 * default-app environment interface
 */
import { ApiConfig } from './api-config';
import { EnvAuth } from './env-auth';
import { InsurerConfig } from './insurer-config';
import { LogConfig } from './log-config';
import { HorizonsConfig } from './horizons-config';

export interface Environment {
  production: boolean;
  insightId: string;
  api: ApiConfig;
  auth: EnvAuth;
  insurer: InsurerConfig;
  appName: string;
  log: LogConfig;
  envName: string;
}

export interface AariFitterAppEnvironment extends Environment {
  horizons: HorizonsConfig;
}
